import { Link } from "react-router-dom";
import { getHotTopics, formatDateC, getCategoryName } from "@/lib/content";

export default function FeaturedTopics() {
  const hotTopics = getHotTopics();
  const [lead, ...rest] = hotTopics;

  if (!lead) return null;

  return (
    <section className="bg-background-50 px-4 py-14 md:px-8 md:py-20">
      <div className="mx-auto w-full max-w-8xl">
        <div className="flex flex-wrap items-end justify-between gap-4">
          <div>
            <div className="mb-3 flex items-center gap-2 text-xs font-medium tracking-[0.28em] text-primary-600">
              <span className="h-px w-6 bg-primary-400" />
              本周热议
            </div>
            <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              呼声最高的几份档案
            </h2>
          </div>
          <Link
            to="/topics"
            className="inline-flex items-center gap-1 whitespace-nowrap text-sm text-primary-600 transition-colors hover:text-primary-700"
          >
            查看全部归档
            <i className="ri-arrow-right-line" />
          </Link>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-6 lg:grid-cols-12">
          <Link
            to={`/topics/${lead.slug}`}
            className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-100 lg:col-span-7"
          >
            <div className="h-64 w-full overflow-hidden bg-background-200 md:h-80">
              <img
                src={lead.cover}
                alt={`${lead.title} 封面`}
                title={`${lead.title} - 黑料吃话热议档案`}
                className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
            </div>
            <div className="p-5 md:p-7">
              <div className="flex flex-wrap items-center gap-x-3 gap-y-2 text-xs text-foreground-500">
                <span className="inline-flex items-center gap-1 rounded-full bg-primary-100 px-2.5 py-0.5 font-medium text-primary-700">
                  <i className="ri-fire-line" />
                  编辑部推荐
                </span>
                <span className="rounded-full bg-secondary-100 px-2.5 py-0.5 font-medium text-secondary-900">
                  {getCategoryName(lead.category)}
                </span>
                <span className="whitespace-nowrap">{formatDateC(lead.date)}</span>
              </div>
              <h3 className="mt-4 font-heading text-xl font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-600 md:text-2xl">
                {lead.title}
              </h3>
              <p className="mt-3 line-clamp-3 text-sm leading-relaxed text-foreground-600 md:text-base">
                {lead.summary}
              </p>
              <div className="mt-5 flex flex-wrap items-center gap-x-5 gap-y-2 text-xs text-foreground-500">
                <span className="flex items-center gap-1 whitespace-nowrap">
                  <i className="ri-time-line" />
                  {lead.readTime}
                </span>
                <span className="flex items-center gap-1 whitespace-nowrap">
                  <i className="ri-eye-line" />
                  {lead.views} 阅读
                </span>
              </div>
            </div>
          </Link>

          <div className="flex flex-col gap-4 lg:col-span-5">
            {rest.map((topic, index) => (
              <Link
                key={topic.id}
                to={`/topics/${topic.slug}`}
                className="group flex flex-1 items-start gap-4 rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-300 hover:bg-background-100 md:p-5"
              >
                <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-md bg-accent-100 font-heading text-sm font-bold text-accent-800">
                  {String(index + 2).padStart(2, "0")}
                </span>
                <div className="min-w-0">
                  <div className="flex flex-wrap items-center gap-x-3 gap-y-1 text-xs text-foreground-500">
                    <span className="rounded-full bg-secondary-100 px-2 py-0.5 font-medium text-secondary-900">
                      {getCategoryName(topic.category)}
                    </span>
                    <span className="whitespace-nowrap">{formatDateC(topic.date)}</span>
                  </div>
                  <h3 className="mt-2 font-heading text-base font-semibold leading-snug text-foreground-950 transition-colors group-hover:text-primary-600">
                    {topic.title}
                  </h3>
                  <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">
                    {topic.summary}
                  </p>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}